import { Flex } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import styles from './not-found.module.scss';
import { Button } from '@/components/button/button';

export function NotFound() {
  const navigate = useNavigate();

  return (
    <Flex vertical align="center" justify="center" style={{ height: '100vh', textAlign: 'center' }}>
      <h1>404</h1>
      <h2> Page Not Found</h2>
      <Flex vertical gap={16}>
        <Link className={styles.link} to="/">
          Back to the main page
        </Link>

        <Button className={styles.link} onClick={() => navigate(-1)}>
          Back to the previous page
        </Button>
      </Flex>
    </Flex>
  );
}
